import React from 'react';
import { compose } from 'redux';
import { PapiDeviation } from '@wix/da-types-papi';
import { withTranslation, WithTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import OnScrollBottom, {
  DISTANCE_UNIT,
} from '@wix/da-shared-react/pkg/OnScrollBottom';
import WidgetHeader from '../../../UserWidgets/_partials/WidgetHeader';
import EmptyState from '../_partials/EmptyState';
import PostsMobileList from '../_partials/PostsMobileList';
import PostsGrid from '../_partials/PostsGrid';
import SortOrderSwitcher from '../_partials/SortOrderSwitcher';
import { PostsSortOrder } from '../../../../../types/posts';
import { USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

import s from './Drafts.scss';

export interface Props {
  streamId: string;
  items: PapiDeviation[];
  hasMore: boolean;
  isFetching: boolean;
  fetchMore: () => void;
  sortOrder: PostsSortOrder;
  onSortOrderChange: (
    path: USER_PROFILE_POSTS_SUB_PATHS,
    sortOrder: PostsSortOrder
  ) => void;
  children?: React.ReactNode;
}

const enhance = compose(
  withSectionFetchSpinner,
  withMobileContext,
  withTranslation()
);
export class Drafts extends React.Component<
  Props & WithTranslation & { isMobile: boolean }
> {
  render() {
    const {
      streamId,
      items,
      hasMore,
      isFetching,
      fetchMore,
      sortOrder,
      isMobile,
    } = this.props;

    if (!items.length) {
      return (
        <EmptyState
          className={s['empty-state']}
          view="large"
          postType="journalDraft"
        />
      );
    }

    return (
      <ErrorBoundary>
        <div>
          {isMobile ? (
            <PostsMobileList streamId={streamId} items={items} />
          ) : (
            <>
              <WidgetHeader
                extras={
                  <SortOrderSwitcher
                    value={sortOrder}
                    onChange={this.updateSortOrder}
                  />
                }
              />
              <PostsGrid streamId={streamId} items={items} isDraft />
            </>
          )}
          {isFetching && <LoadingIndicator />}
          <OnScrollBottom
            distanceToBottom={2}
            distanceUnit={DISTANCE_UNIT.WINDOW_HEIGHT}
            onScrolledToBottom={hasMore && !isFetching ? fetchMore : undefined}
          />
        </div>
      </ErrorBoundary>
    );
  }

  updateSortOrder = sortOrder => {
    const { onSortOrderChange } = this.props;
    onSortOrderChange &&
      onSortOrderChange(USER_PROFILE_POSTS_SUB_PATHS.DRAFTS, sortOrder);
  };
}

export default enhance(Drafts) as React.ComponentType<Props>;
